import { createSelector } from "../../../utils/createSelector.es.js";
const gridVirtualizationSelector = (state) => state.virtualization;
const gridVirtualizationEnabledSelector = createSelector(gridVirtualizationSelector, (state) => state.enabled);
const gridVirtualizationColumnEnabledSelector = createSelector(gridVirtualizationSelector, (state) => state.enabledForColumns);
export {
  gridVirtualizationColumnEnabledSelector,
  gridVirtualizationEnabledSelector,
  gridVirtualizationSelector
};
//# sourceMappingURL=gridVirtualizationSelectors.es.js.map
